module.exports = __webpack_public_path__ + "static/media/video1-underwood.f6dba197.mp4";